import axios from "./axios.js";
class Interface {
  //添加慰问接口
  addSympathy(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //慰问查询接口
  selectSympathy(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //慰问制度
  getArrovalInfo(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //个人总积分接口
  integralAll(url, fun, data) {
    data.id = data.userId;
    axios.postRequest(url, fun, data);
  }
  //个人总步数接口
  stepAll(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //首页的功能专区
  getUserMenuAPP(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //资讯分类列表
  getNewsType(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //首页轮播图
  getNewsCarouselAPP(url, fun, data) {
    axios.postRequest(url, fun, data);
  }

  //获取用户菜单
  getUserIdMenuAPP(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }

  //获取全部菜单
  getAllMenuAPP(url, fun, data) {
    axios.postRequest(url, fun, data);
  }

  //保存用户菜单
  saveUserIdMenuAPP(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }

  //资讯分类列表app
  getNewsTypeAPP(url, fun, data) {
    axios.postRequest(url, fun, data);
  }

  //资讯分类列表详情数据
  getNewsList(url, fun, data, allData) {
    data.staffId = data.userId;
    data.deptId = allData.deptId;
    data.unionId = allData.unionId;
    axios.postRequest(url, fun, data);
  }
  //资讯分类列表详情数据app
  getNewsListAPP(url, fun, data, allData) {
    data.staffId = data.userId;
    data.deptId = allData.deptId;
    data.unionId = allData.unionId;
    axios.postRequest(url, fun, data);
  }

  // 获取人员属性list
  getListDate(url, fun, data) {
    //登录人Id
    data.id = data.userId;
    axios.postRequest(url, fun, data);
  }
  // 获取人员属性详细信息
  getStaffDetails(url, fun, data) {
    data.id = data.userId;
    axios.postRequest(url, fun, data);
  }

  //获取数据字典根据字典类型
  getDictValue(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //七日步数统计
  sevenStep(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //获取动态属性字典
  getFieldValue(url, fun, data) {
    axios.postRequest(url, fun, data);
  }

  //日周月总步数统计
  staffRankByType(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //日周月步数柱状统计
  getStaffStepStatistic(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }

  //获取步数授权
  getSignature(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }

  //积分明细
  integralDetail(url, fun, data) {
    data.id = data.userId;
    axios.postRequest(url, fun, data);
  }

  //积分制度
  integralSystem(url, fun, data) {
    axios.postRequest(url, fun, data);
  }

  //获取福利列表
  getWelfareList(url, fun, data) {
    data.unionId = data.userId;
    axios.postRequest(url, fun, data);
  }

  //线上活动查询
  wxOLActivityDetails(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //线上活动提交
  submitFilesForActivity(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //线上活动更新
  updateSubmitedFilesForActivity(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  // 获取已提交的线上活动数据
  getSubmitFilesOfActivity(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  // 上传图片
  uploadFile(url, fun, data) {
    var form = new FormData(); // FormData 对象
    //去掉 element-ui对file的增强  element-ui底层对file进行了封装 raw是原本的文件流
    form.append("file", data.file); // 文件对象
    form.append("unitCode", data.unitCode); //上级单位编码
    form.append("hospitalCode", data.hospitalCode); //医院编码
    axios.postFileRequest(url, fun, form);
  }
  //慰问上传带图片的
  enquiryAgent(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取分会数据和流程数据
  getOfficeTree(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  getOneData(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //查询流程
  queryHistoricActivitiInstancebyPlanid(url, fun, data) {
    data["sendType"] = "queryHistoricActivitiInstancebyPlanid";
    axios.postRequest(url, fun, data);
  }
  //获取我的慰问
  myComforts(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //审核
  approval(url, fun, data, allData) {
    data["sendType"] = "approval";
    data.userName = allData.name;
    axios.postRequest(url, fun, data);
  }
  //保存签名
  saveSignature(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取审批签名开关
  getAutograph(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取困难补助信息
  getAcquisitionSystem(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取当前问卷所有的题目
  getCurrentQuestionAllSubject(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  // 答卷提交
  saveQuestionAnswer(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  // 考试得分计算
  getQuestionScore(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取城市列表
  getCityList(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取用户收货地址列表
  getAddressByStaff(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //新增地址
  addOrUpdateAddress(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //删除地址
  delAddress(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //兑换记录
  orderList(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //下单
  saveOrder(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //商品详情
  listProduct(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //确认订单
  createOrder(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //商城首页
  eShopProductList(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  // 资讯详情
  getNewsDetail(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  // 获取积分参数
  getIntegralData(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  // 资讯积分
  setStaffPointAPP(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //获取大会列表
  wechatRepreList(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取详情
  wechatRepreDetail(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //提价意见
  subDemoraticVoteSuggest(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //提交表决
  subDemoraticVoteRecord(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取征集
  wechatProposalList(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取征集附议
  wechatProposalSupportList(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  proposalDetail(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //人员获取
  personnelWechatRepreList(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //保存提案
  saveProposal(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //查看详情
  proposalAndSignatureDetail(url, fun, data) {
    data.staffId = data.userId;
    axios.postRequest(url, fun, data);
  }
  //提交附议人员
  inviteSupportProposal(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //
  signatureDetail(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //附议代表签名
  supportSignatrueSubmit(url, fun, data) {
    axios.postRequest(url, fun, data);
  }

  //submitProposal
  submitProposal(url, fun, data) {
    axios.postRequest(url, fun, data);
  }

  //获取人员信息
  findLeaderAndDeptList(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //修改保存个人信息
  updateStaffPhotoAPP(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  // 根据字典名称获取用户自定义数据字典（返回在用的数据字典）
  getUserDictValue(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  // 获取首页：LOGO
  getActivityolSystemGallery(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取住院慰问类型
  getUserDictValue(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取住院慰问类型  全部（包含删除的）
  getUserDictValueAllData(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取慰问字典
  getDictionaryList(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取活动报名类型
  getSignUpType(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //按人员报名
  signUpByStaff(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //获取组织信息
  getUnionAndDeptRepreTree(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
  //删除附议代表
  deleteInviteProposal(url, fun, data) {
    axios.postRequest(url, fun, data);
  }
}
let interfaceClass = new Interface();
export default interfaceClass;
